import constants from "../constants"

const Breakpoints = (w) => {
  const between = (x, min, max) => {
    return x >= min && x <= max
  }
  const brakes = [
     { id: `sm`, min: 0, max: constants.breakpoints.sm },
     { id: `md`, min: constants.breakpoints.sm, max: constants.breakpoints.md },
     { id: `lg`, min: constants.breakpoints.md, max: constants.breakpoints.lg },
     { id: `xl`, min: constants.breakpoints.lg, max: Infinity },
    //  { id: `xxl`, min: constants.breakpoints.xl, max: Infinity },
    //  { id: `huge`, min: constants.breakpoints.xxl, max: Infinity }
  ]
  return brakes.filter(item => between(w, item.min, item.max))[0]
}

export default Breakpoints